import { ActionTypes } from '../constants/index';

export const getParticipantDetails = (payload: any) => ({
  type: ActionTypes.PARTICPANT_LIST_REQUEST,
  payload,
});
